import { Badge } from 'root/src/client/v2/common/components/badge/Badge';
import { TierBadge } from 'root/src/client/v2/battlePass/components/TierBadge';
import { DareCardBattlePass } from 'root/src/client/v2/battlePass/features/BattlePassDetails/components/DaresBattlePass/DareCardBattlePass';
import { daresTabs } from 'root/src/client/v2/battlePass/constants';
import { useBattlePassDaresPagination, useBattlePassDaresStatus, useBattlePassTier, } from 'root/src/client/v2/battlePass/features/BattlePassDetails/contexts/battlePassDetails.context';
import Pager from 'root/src/client/web/base/Pager';
import CloudOffIcon from '@material-ui/icons/CloudOff';
import LoadingCircles from 'root/src/client/v2/common/components/LoadingCircles';
import { useBattlePassDetails, } from 'root/src/client/v2/battlePass/features/BattlePassDetails/hooks/useBattlePassDetails';
export const DaresBattlePass = () => {
    const { tier } = useBattlePassTier();
    const { isLoading } = useBattlePassDetails();
    if (isLoading) {
        return <LoadingCircles />;
    }
    return (<div className="flex flex-col mt-4">
			<h2 className="font-medium text-3xl font-mono">Tier {tier} Dares</h2>
			<TabsDaresBattlePass />
			<DaresSeparator />
			<DaresGrid />
		</div>);
};
const TabsDaresBattlePass = () => {
    const { dareStatus, setDareStatus } = useBattlePassDaresStatus();
    return (<div className="flex flex-start gap-2 mt-5">
			{daresTabs.map((dareTab) => {
            const isActive = dareStatus === dareTab.status;
            return (<DareTab key={dareTab.label} label={dareTab.label} isActive={isActive} onClick={() => setDareStatus(dareTab.status)}/>);
        })}
		</div>);
};
const DareTab = ({ label, isActive = false, onClick }) => {
    return (<Badge data-active={isActive} onClick={onClick} className="cursor-pointer capitalize data-[active=true]:motion-safe:animate-slide-up hover:brightness-100 motion-safe:duration-150 bg-primary brightness-50 data-[active=true]:brightness-100">
			{label}
		</Badge>);
};
export const DaresSeparator = () => {
    const { tier } = useBattlePassTier();
    return (<div className="flex justify-center items-center w-[80%] m-auto">
			<div className="w-[40%] h-[1px] bg-light-4"/>
			<TierBadge tier={tier} label={`Tier ${tier}`} isActive className="cursor-default"/>
			<div className="w-[40%] h-[1px] bg-light-4"/>
		</div>);
};
const DaresGrid = () => {
    const { drops } = useBattlePassDetails();
    const { dares, setCurrentPage, currentPage, allPage } = useBattlePassDaresPagination();
    if (!dares.length) {
        return (<NoDares />);
    }
    const minHeight = (allPage === 1 && dares.length < 4) ? 480 : 960;
    return (<div className="flex flex-col justify-center">
			<div style={{ minHeight: `${minHeight}px` }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mt-3 w-full m-auto justify-items-center">
				{dares.map(({ dropId, dare }) => {
            const drop = drops.find(({ id }) => id === dropId);
            return (<DareCardBattlePass key={dare.id} dare={dare} drop={drop}/>);
        })}
			</div>
			<Pager className="scale-150 mt-6" currentPage={currentPage} allPage={allPage} getPage={newPage => setCurrentPage(newPage)}/>
		</div>);
};
const NoDares = () => {
    return (<div className="flex flex-col gap-1 items-center mt-10 min-h-[480px]">
			<CloudOffIcon fontSize="large" className="!fill-pink animate-[slide-up_.4s]"/>
			<span className="text-pink uppercase font-bold text-sm animate-[slide-up_.4s]">No dares available</span>
		</div>);
};
